import {observer} from "mobx-react";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {DialogStore, growlStore, pmsCreateStore, validationStore} from "../../../store";
import {useState} from "react";
import {useNavigate} from "react-router";
import {PmsForm, PmsFormValidation} from "./PmsForm";

const PmsCreatePage = observer(function PmsCreatePage() {
    const [cancelDialog] = useState(new DialogStore())
    const navigate = useNavigate()


    const validation: PmsFormValidation = {
        displayName: validationStore.getFor('displayName'),
        name: validationStore.getFor('name'),
        type: validationStore.getFor('type')
    }

    const display = 'Neuen Drucker anlegen'

    return <Page
        breadcrumb={[
            {
                link: '/pms',
                label: 'Druckerverwaltung'
            },
            {
                link: '/pms/create',
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        pmsCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/pms')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${pmsCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(pmsCreateStore.dirty && pmsCreateStore.valid),
                    action: async () => {
                        const id = await pmsCreateStore.create()
                        pmsCreateStore.reset()
                        growlStore.add({
                            message: 'Der Drucker wurde erfolgreich hinzugefügt',
                            autoclose: true,
                            closable: true
                        })
                        navigate(`/pms/${id}`)
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: pmsCreateStore.creating || !pmsCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <PmsForm
            validation={validation}
            data={pmsCreateStore.formData}
            onChange={data => pmsCreateStore.formData = data}
            onBlur={() => pmsCreateStore.validate()}
        />
    </Page>
})

export {
    PmsCreatePage
}
